import { newVue } from '@/config/vue'
import App from './App.vue'
import router from './router'

On.VueInit({
  controller: 'spa',
  init() {
    newVue({
      router,
      render: h => h(App),
      mount: '.js-spa',
    })
  },
})
